import React, { useContext } from 'react';
import { DebugContext } from '../../contexts/DebugContext';
import { IInteriorProduct } from '../../models/IChainInfo';
import { IInteriorProductMaterial } from '../../services/WebApiClient';


export function ProductDebugInfo(props: {
    product: IInteriorProduct;
    material: IInteriorProductMaterial | undefined;

}) {
    const debugContext = useContext(DebugContext);

    if (!debugContext.value.displayExtendedProductInfo)
        return null;
    const {
        product,
        material,
    } = props;

    return (
        <div>
            <div>
                Product group: {product.productSubGroup.productGroup.externalId}
            </div>
            <div>
                Product sub group: {product.productSubGroup.externalId}
            </div>
            <div>
                Product: {product.externalId}
            </div>
            <div>
                Material: {material?.externalId ?? " -- "}
            </div>
            <div>
                Other products in subgroup:
                <ul>
                    {product.productSubGroup.products.map(p => (
                        <li key={p.id} >
                            {p.externalId}
                            <ul>
                                {p.materials.map(m => (
                                    <li key={m.interiorMaterialId}>
                                        {m.name}: {m.externalId ?? ' -- '}
                                    </li>
                                    ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
